import classnames from 'classnames/bind'
import Cookies from 'js-cookie'
import React, { useCallback } from 'react'
import { GlobalThemeColors } from '~/@types/colors'
import { GlobalGridPreset } from '~/@types/grid-preset'
import { GlobalTextPreset } from '~/@types/text-preset'
import { GlobalTextStyling } from '~/@types/text-styling'
import { COOKIE_KEYS, NEWSLETTER_TAGS } from '~/lib/constants'

import RichText, { RichTextBlock } from '~/components/Abstracts/RichText'
import Newsletter from '~/components/Form/Newsletter'
import FooterLogo from '~/components/UI/Footer/FooterLogo'

import { useGlobalData } from '~/providers/GlobalDataProvider'
import { useStyle } from '~/providers/StyleProvider'

import useCurrency from '~/hooks/useCurrency'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export type PushNewsletterProps = {
  className?: string
  title?: RichTextBlock
  subtitle?: RichTextBlock
  text?: RichTextBlock
}

function PushNewsletter({
  className,
  title,
  subtitle,
  text,
}: PushNewsletterProps) {
  const { global } = useGlobalData()
  const gridStyle = useStyle({ grid: GlobalGridPreset.BASE_GRID })
  const titleStyle = useStyle({ textPreset: GlobalTextPreset.Title40SangBleu })
  const subtitleStyle = useStyle({
    textPreset: GlobalTextPreset.Label12SangBleu,
    textStyling: GlobalTextStyling.Italic,
  })
  const textStyle = useStyle({
    textPreset: GlobalTextPreset.Cta10GroteskRegular,
    textStyling: GlobalTextStyling.UpperCase,
  })

  const currency = useCurrency()

  const success = useCallback(() => {
    Cookies.set(COOKIE_KEYS.newsletterPopIn(currency), '1', { expires: 365 })
    // onSuccess?.()
  }, [])

  return (
    <div className={cx(css.PushNewsletter, className)}>
      <div className={gridStyle}>
        <div className={css.logoWrapper}>
          <FooterLogo theme={GlobalThemeColors.Amber} className={css.logo} />
        </div>
        {(title || subtitle) && (
          <div className={css.top}>
            {title && (
              <RichText render={title} className={cx(css.title, titleStyle)} />
            )}
            {subtitle && (
              <RichText
                render={subtitle}
                className={cx(css.subtitle, subtitleStyle)}
              />
            )}
          </div>
        )}
        <div className={css.body}>
          <Newsletter
            className={css.newsletter}
            inputClassName={cx(css.newsletterInput)}
            fromTag={NEWSLETTER_TAGS.POPIN}
            gdprClassName={css.optin}
            gdprLabel={global?.newsletter?.gdprLabel}
            gdprText={global?.newsletter?.gdprText}
            onSuccess={success}
            uniqueId="push-newsletter"
            textSubmit
            isInline={false}
          />
        </div>
        {text && (
          <div className={css.bottom}>
            <RichText render={text} className={cx(css.text, textStyle)} />
          </div>
        )}
      </div>
    </div>
  )
}

PushNewsletter.defaultProps = {}

export default PushNewsletter
